import React, {  useState } from "react";
import { Modal, Button  } from 'antd';
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { connect } from "react-redux";
import { updateExercise } from "../../../actions/Exercise.actions";
import { setAlert } from "../../../actions/alert";
import {FontSizeOutlined } from "@ant-design/icons"

  const UpdateExercise = ({ updateExercise, correntExercise, setAlert }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [Exercise, setExercise] = useState({
    id: correntExercise._id,
    description: correntExercise.description,
  });

  const { description } = Exercise;

  const onSubmit = async (e) => {
    e.preventDefault();
    updateExercise(Exercise);
    setAlert("تم التعديل علي بيانات الدرس", "success");
    setIsModalVisible(false);
  };

  return (
    <>
    <Button size="large" onClick={showModal}><FontSizeOutlined /></Button>
   
    <Modal title="إضافة  نص" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}
    footer={[
    <Button key="back" onClick={handleCancel}>
      إلغاء الامر
    </Button>,
    <Button key="submit" type="primary"  onClick={onSubmit}>
      إضافة
    </Button>,
    ]}
    >
    <form onSubmit={onSubmit}>
    <label htmlFor="firstName" className="active">
              النص
            </label>
            <CKEditor
              editor={ClassicEditor}
              data={description}
              onChange={(event, editor) => {
                const data = editor.getData();
                setExercise({ ...Exercise, description: data });
              }}
            />
    </form>
    </Modal>
  </>

     
  );
};

export default connect(null, {
  updateExercise,
  setAlert,
})(UpdateExercise);
